module.exports = __webpack_public_path__ + "static/media/countdown.86b493ad.jpg";